import moment from 'moment';
import numbro from 'numbro';

export function formatPercentage(percentage) {
  if (percentage === undefined || percentage === null) {
    return '-';
  }
  return numbro(+percentage / 100).format('0.00%');
}

export function formatPercentageRounded(percentage) {
  if (percentage === undefined || percentage === null) {
    return '-';
  }
  return numbro(+percentage / 100).format('0%');
}

export function formatMonth(date) {
  if (date === undefined || date === null) {
    return '-';
  }
  return moment(date).format('MMMM YYYY');
}

export function formatDate(date) {
  if (date === undefined || date === null) {
    return '-';
  }
  return moment(date).format('MMMM D, YYYY');
}

export function formatDateShortMonth(date) {
  if (date === undefined || date === null) {
    return '-';
  }
  return moment(date).format('MMM D, YYYY');
}

export function formatShortDateWithoutYear(date) {
  if (date === undefined || date === null) {
    return '-';
  }
  return moment(date).format('MMM D');
}

export function formatDateFromNow(date) {
  if (date === undefined || date === null) {
    return '-';
  }
  return moment(date).fromNow();
}

export function formatCurrency(number) {
  if (number === undefined || number === null) {
    return '-';
  }
  return numbro(+number).formatCurrency('(0,0[.]00)');
}

export function formatCurrencyRounded(number) {
  if (number === undefined || number === null) {
    return '-';
  }
  return numbro(+number).formatCurrency('(0,0)');
}

export function formatCurrencyWithMantissa(number) {
  if (number === undefined || number === null) {
    return '-';
  }
  return numbro(+number).formatCurrency('(0[.]0a)');
}

export function valueOrDash(value) {
  if (value === undefined || value === null) {
    return '-';
  }
  return value;
}

export default {
  formatPercentage,
  formatPercentageRounded,
  formatMonth,
  formatDate,
  formatDateShortMonth,
  formatShortDateWithoutYear,
  formatDateFromNow,
  formatCurrency,
  formatCurrencyRounded,
  formatCurrencyWithMantissa,
  valueOrDash,
};
